import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "star" }, [
      _createElementVNode("g", { id: "elements" }, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M16.0156 4.01848L18.0687 8.15862C18.3487 8.73495 19.0953 9.28776 19.7252 9.39361L23.4465 10.017C25.8262 10.4169 26.3861 12.1576 24.6713 13.8748L21.7783 16.7918C21.2884 17.2858 21.0201 18.2385 21.1717 18.9207L22 22.5315C22.6532 25.3896 21.1484 26.4952 18.6403 25.0015L15.1524 22.9197C14.5224 22.5433 13.4842 22.5433 12.8426 22.9197L9.35469 25.0015C6.8583 26.4952 5.3418 25.3779 5.99506 22.5315L6.8233 18.9207C6.97495 18.2385 6.70665 17.2858 6.2167 16.7918L3.32369 13.8748C1.62054 12.1576 2.16881 10.4169 4.54855 10.017L8.26981 9.39361C8.88807 9.28776 9.63466 8.73495 9.91462 8.15862L11.9677 4.01848C13.0876 1.77198 14.9074 1.77198 16.0156 4.01848Z",
          stroke: "white",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }